import { Box } from "@mui/material";
import EcommerceMetrix from "components/cards/statistics/EcommerceMetrix";
import {
  UserSwitchOutlined,
  TeamOutlined,
  LogoutOutlined,
  ClockCircleOutlined,
  FieldTimeOutlined,
} from "@ant-design/icons";
import { IEntryExitDashboardSummary } from "../api/types";

interface KpiSummaryCardsProps {
  summary?: IEntryExitDashboardSummary;
  isLoading?: boolean;
  isFiltered: boolean;
}

export default function KpiSummaryCards({
  summary,
  isFiltered,
}: KpiSummaryCardsProps) {
  function formatNumberWithCommas(num?: number) {
    return num !== undefined ? num.toLocaleString("en-IN") : "0";
  }

  const formatDuration = (mins?: number) => {
    if (!mins || mins <= 0) return "0 min";
    const hours = Math.floor(mins / 60);
    const remainingMins = mins % 60;
    if (hours > 0 && remainingMins > 0) return `${hours}h ${remainingMins}m`;
    if (hours > 0) return `${hours} hr${hours > 1 ? "s" : ""}`;
    return `${remainingMins} min`;
  };

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, 1fr)",
          md: "repeat(3, 1fr)",
          lg: "repeat(5, 1fr)",
        },
        gap: 1.5,
        mb: 2,
      }}
    >
      <Box>
        <EcommerceMetrix
          primary={isFiltered ? "Total Visits" : "Today Visitors"}
          secondary={formatNumberWithCommas(summary?.totalVisits)}
          content={
            isFiltered
              ? `Today: ${formatNumberWithCommas(summary?.todayVisits)}`
              : "All entries today"
          }
          color="#ff9800"
          iconPrimary={UserSwitchOutlined}
        />
      </Box>
      <Box>
        <EcommerceMetrix
          primary="Currently Inside"
          secondary={formatNumberWithCommas(summary?.currentlyInLibrary)}
          content="Live active in library"
          color="success.main"
          iconPrimary={TeamOutlined}
        />
      </Box>
      <Box>
        <EcommerceMetrix
          primary={isFiltered ? "Total Exits" : "Today Exits"}
          secondary={formatNumberWithCommas(summary?.totalExits)}
          content="Recorded departures"
          color="error.main"
          iconPrimary={LogoutOutlined}
        />
      </Box>
      <Box>
        <EcommerceMetrix
          primary="Avg Duration"
          secondary={formatDuration(summary?.avgDurationMinutes)}
          content="Average time spent"
          color="#673ab7"
          iconPrimary={ClockCircleOutlined}
        />
      </Box>
      <Box>
        <EcommerceMetrix
          primary="Today Visits"
          secondary={formatNumberWithCommas(summary?.todayVisits)}
          content={`${formatNumberWithCommas(
            summary?.todayCurrentlyInLibrary
          )} active inside`}
          color="info.main"
          iconPrimary={FieldTimeOutlined}
        />
      </Box>
    </Box>
  );
}

